// 设置企业编码

export const getCompanyPort = () => {
  return window.localStorage.getItem("companyPort") || '';
};

export const setCompanyPort = (prot: string) => {
  window.localStorage.setItem("companyPort", prot);
};

/**
 * 设置登录公共编码
 */
export const setPublicCompanyPort = (prot: string) => {
  window.localStorage.setItem("publicCompanyPort", prot);
}

/**
 * 获取登录公共编码
 */
export const getPublicCompanyPort = () => {
  return window.localStorage.getItem("publicCompanyPort") || '';
}